import React from 'react';
import clsx from 'clsx';

/**
 * Used-vs-limit bar. A limit of 0/undefined means "not included in the plan"
 * — shown as such rather than as 0 of 0, which reads like a bug.
 */
export const UsageBar: React.FC<{
  icon: React.ReactNode;
  label: string;
  used: number;
  limit?: number;
  delay?: number;
}> = ({ icon, label, used, limit, delay = 0 }) => {
  const hasLimit = typeof limit === 'number' && limit > 0;
  const pct = hasLimit ? Math.min(100, Math.round((used / limit!) * 100)) : used > 0 ? 100 : 0;
  const over = hasLimit && used > limit!;
  const tone = over ? 'bg-danger' : pct >= 90 ? 'bg-warning' : 'bg-primary';

  return (
    <div className="fade-up" style={{ animationDelay: `${delay}ms` }}>
      <div className="mb-1.5 flex items-center justify-between text-xs">
        <span className="inline-flex items-center gap-1.5 text-text-primary">
          <span className="text-text-muted">{icon}</span>{label}
        </span>
        <span className={clsx('tabular-nums', over ? 'font-semibold text-danger' : 'text-text-muted')}>
          {used.toLocaleString()}{hasLimit ? ` / ${limit!.toLocaleString()}` : limit === 0 ? ' · not in plan' : ''}
        </span>
      </div>
      <div className="h-1.5 w-full overflow-hidden rounded-full bg-border/70">
        <div
          className={clsx('bar-grow h-full rounded-full', tone)}
          style={{ width: `${pct}%`, animationDelay: `${delay + 150}ms` }}
        />
      </div>
    </div>
  );
};
